import React from "react";

import classNames from "classnames";

import PagerButton from "./PagerButton";

type PagerButtonProps = {
	disabled?: boolean;
	page: number;
	active?: boolean;
	children?: JSX.Element | JSX.Element | string | number;
	onPageChange: (newPage: number) => void;
};

export default function IconButton(
	props: PagerButtonProps & { previous?: boolean }
) {
	const iconClassNames = classNames("u-icon u-icon--tny", {
		"u-icon--caret--left": props.previous,
		"u-icon--caret--right": !props.previous,
	});

	return (
		<PagerButton {...props}>
			<i className={iconClassNames} />
		</PagerButton>
	);
}
